(function () {
	const config = {
		lazyClass: 'lazyload',
		loadedClass: 'lazyloaded',
		loadingClass: 'lazyloading',
		errorClass: 'lazyerror',
	};

	let elements: any;
	let loadMode = 2;
	let isCompleted: any;
	let resetPreloadingTimer: number | undefined;
	let started: any;
	let isBodyHidden: any;
	let currentExpand = 0;
	let isLoading = 0;
	let lowRuns = -1;

	const getCSS = function (elem: any, style: any) {
		return (getComputedStyle(elem) || {})[style];
	};

	const rAF = (function () {
		let running: boolean;
		let waiting: boolean;
		const firstFns: any[] = [];
		const secondFns: any[] = [];
		let fns = firstFns;

		const run = function () {
			const runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while (runFns.length) {
				runFns.shift()();
			}

			running = false;
		};

		const rafBatch: any = function (fn: any, queue?: any) {
			if (running && !queue) {
				fn();
			} else {
				fns.push(fn);

				if (!waiting) {
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	const throttle = function (fn: any) {
		let running: boolean;
		let lastTime = 0;

		const idleCallback = () =>
			rAF(() => {
				setTimeout(() => {
					running = false;
					lastTime = Date.now();
					fn();
				});
			});

		return function () {
			if (running) {
				return;
			}

			running = true;

			let delay = 125 - (Date.now() - lastTime);

			if (delay < 0) {
				delay = 0;
			}

			if (delay < 9) {
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	const debounce = function (func: any) {
		let timeout: any;
		let timestamp: any;
		const wait = 99;
		const run = function () {
			timeout = null;
			func();
		};
		const later = function () {
			const last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function () {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	const isNestedVisible = function (elem: any, elemExpand: any, rect: any) {
		let parent = elem;
		if (isBodyHidden == null) {
			isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
		}

		let visible =
			isBodyHidden ||
			!(
				getCSS(elem.parentNode, 'visibility') == 'hidden' &&
				getCSS(elem, 'visibility') == 'hidden'
			);

		const eLtop = rect.top - elemExpand;
		const eLbottom = rect.bottom + elemExpand;
		const eLleft = rect.left - elemExpand;
		const eLright = rect.right + elemExpand;

		while (
			visible &&
			(parent = parent.offsetParent) &&
			parent != document.body &&
			parent != document.documentElement
		) {
			visible = (getCSS(parent, 'opacity') || 1) > 0;

			if (visible && getCSS(parent, 'overflow') != 'visible') {
				const outerRect = parent.getBoundingClientRect();
				visible =
					eLright > outerRect.left &&
					eLleft < outerRect.right &&
					eLbottom > outerRect.top - 1 &&
					eLtop < outerRect.bottom + 1;
			}
		}

		return visible;
	};

	const checkElements = function () {
		if (loadMode && isLoading < 8 && elements.length) {
			lowRuns++;

			const defaultExpand =
				document.documentElement.clientHeight > 500 &&
				document.documentElement.clientWidth > 500
					? 500
					: 370;
			const preloadExpand = defaultExpand * 1.5;
			isBodyHidden = null;

			if (
				currentExpand < preloadExpand &&
				isLoading < 1 &&
				lowRuns > 2 &&
				loadMode > 2 &&
				!document.hidden
			) {
				currentExpand = preloadExpand;
				lowRuns = 0;
			} else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
				currentExpand = defaultExpand;
			} else {
				currentExpand = 0;
			}

			for (let i = 0; i < elements.length; i++) {
				if (!elements[i] || elements[i].dataset._lazyRace) {
					continue;
				}

				const rect = elements[i].getBoundingClientRect();

				if (
					rect.bottom >= currentExpand * -1 &&
					rect.top <= window.innerHeight + currentExpand &&
					rect.right >= currentExpand * -1 * 0.8 &&
					rect.left <= window.innerWidth + currentExpand * 0.8 &&
					(rect.bottom || rect.right || rect.left || rect.top) &&
					((isCompleted && isLoading < 3 && (loadMode < 3 || lowRuns < 4)) ||
						isNestedVisible(elements[i], currentExpand, rect))
				) {
					unveilElement(elements[i]);
					if (isLoading > 9) {
						break;
					}
				}
			}
		}
	};

	const throttledCheckElements = throttle(checkElements);

	const unveilElement = function (elem: HTMLImageElement) {
		if (elem.dataset._lazyRace) {
			return;
		}

		if (
			!isCompleted &&
			!elem.complete &&
			!elem.classList.contains(config.errorClass) &&
			elem.classList.contains(config.lazyClass)
		) {
			return;
		}

		const src = getSizeElement(elem);

		elem.dataset._lazyRace = 'true';
		isLoading++;

		rAF(() => {
			elem.classList.add(config.loadingClass);

			const resetPreloading = function () {
				isLoading--;
				if (isLoading < 0) {
					isLoading = 0;
				}
			};

			clearTimeout(resetPreloadingTimer);
			resetPreloadingTimer = setTimeout(resetPreloading, 2500);

			const switchLoadingClass = () => {
				if (elem.dataset._lazyCache) {
					delete elem.dataset._lazyCache;
					return;
				}

				resetPreloading();
				elem.classList.add(config.loadedClass);
				elem.classList.remove(config.loadingClass);
				['load', 'error'].forEach(function (evt) {
					elem.removeEventListener(evt, rafedSwitchLoadingClass);
				});

				const event = document.createEvent('Event');
				event.initEvent('lazyloaded', true, true);
				elem.dispatchEvent(event);
			};
			const rafedSwitchLoadingClass = (e) => rAF(() => switchLoadingClass());

			['load', 'error'].forEach(function (evt) {
				elem.addEventListener(evt, rafedSwitchLoadingClass);
			});

			elem.src = src;

			if (elem.dataset._lazyRace) {
				delete elem.dataset._lazyRace;
			}

			elem.classList.remove(config.lazyClass);

			rAF(() => {
				const isLoaded = elem.complete && elem.naturalWidth > 1;

				if (isLoaded) {
					switchLoadingClass();
					elem.dataset._lazyCache = 'true';
					setTimeout(() => {
						if (elem.dataset._lazyCache) {
							delete elem.dataset._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});
	};

	const load = function () {
		if (isCompleted) {
			return;
		}
		if (Date.now() - started < 999) {
			setTimeout(load, 999);
			return;
		}

		isCompleted = true;

		loadMode = 3;

		throttledCheckElements();

		const afterScroll = debounce(function () {
			loadMode = 3;
			throttledCheckElements();
		});

		window.addEventListener(
			'scroll',
			() => {
				if (loadMode == 3) {
					loadMode = 2;
				}
				afterScroll();
			},
			true
		);
	};

	const getSizeElement = function (elem: HTMLImageElement) {
		let parent = elem.parentElement;
		const url = new URL(elem.dataset.src as string, document.baseURI);

		if (parent) {
			let width = elem.offsetWidth;
			let height = elem.offsetHeight;

			while (width < 40 && parent) {
				width = parent.offsetWidth;
				height = parent.offsetHeight;
				parent = parent.parentElement;
			}

			if (elem.getAttribute('data-dynamic-width')?.toLowerCase() == "true") {
				url.searchParams.set('width', (width * window.devicePixelRatio).toString());
			}
			if (elem.getAttribute('data-dynamic-height')?.toLowerCase() == "true" ) {
				url.searchParams.set('height', (height * window.devicePixelRatio).toString());		
			} else {
				const originalWidth = +url.searchParams.get('width')!;
				const originalHeight = +url.searchParams.get('height')!;
				let newHeight = originalHeight * window.devicePixelRatio;
	
				if (originalHeight && originalWidth) {
					newHeight =
						(originalHeight / originalWidth) * width * window.devicePixelRatio;
				}

				if (newHeight !== 0) {
					url.searchParams.set('height', newHeight.toString());
				}
			}
		}

		return url.toString();
	};

	setTimeout(function () {
		elements = document.getElementsByClassName(config.lazyClass);

		window.addEventListener(
			'resize',
			debounce(function () {
				document
					.querySelectorAll<HTMLImageElement>('.lazyloaded')
					.forEach((e) => {
						const url = getSizeElement(e);

						rAF(() => {
							e.src = url;
						});
					});
			})
		);

		window.addEventListener('scroll', throttledCheckElements, true);
		window.addEventListener('resize', throttledCheckElements, true);
		window.addEventListener('hashchange', throttledCheckElements, true);
		window.addEventListener('load', load);

		window.addEventListener('pageshow', function (e) {
			if (!e.persisted) {
				return;
			}
			const loadingElements = document.querySelectorAll<HTMLImageElement>(
				'.' + config.loadingClass
			);

			requestAnimationFrame(function () {
				loadingElements.forEach(function (img) {
					if (img.complete) {
						unveilElement(img);
					}
				});
			});
		});

		new MutationObserver(throttledCheckElements).observe(
			document.documentElement,
			{
				childList: true,
				subtree: true,
				attributes: true,
			}
		);

		[
			'focus',
			'mouseover',
			'click',
			'load',
			'transitionend',
			'animationend',
			'DOMContentLoaded',
		].forEach(function (name) {
			document.addEventListener(name, throttledCheckElements, true);
		});

		if (/d$|^c/.test(document.readyState)) {
			load();
		} else {
			setTimeout(load, 20000);
		}

		checkElements();
		rAF._lsFlush();
	});
})();
